export const formatAvaName = (avaName) => {
    if (!avaName)
        return '';
    const validAvaName = avaName.replace(/[^A-Z0-9]/gi, '');
    return validAvaName.toLocaleLowerCase();
};
export const isAvaRoomValid = (room) => typeof room === 'string' && room && room.length >= 3;
